import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=795731d8&scoped=true"
import script from "./QuestionForm.ts?vue&type=script&lang=ts&external"
export * from "./QuestionForm.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&id=795731d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795731d8",
  null
  
)

export default component.exports